import type { ReactNode } from 'react';

interface SectionShellProps {
  id?: string;
  labelledBy?: string;
  surface?: 'base' | 'subtle';
  className?: string;
  innerClassName?: string;
  children: ReactNode;
}

/** Shared content shell: same max width, left/right edges and padding for every standard section. */
export default function SectionShell({
  id, labelledBy, surface = 'base', className = '', innerClassName = '', children,
}: SectionShellProps) {
  return (
    <section
      id={id}
      aria-labelledby={labelledBy}
      className={`scroll-mt-16 px-4 py-16 md:px-10 md:py-24 ${surface === 'subtle' ? 'bg-background-100' : 'bg-background-50'} ${className}`}
    >
      <div className={`mx-auto w-full max-w-[1200px] ${innerClassName}`}>{children}</div>
    </section>
  );
}